<template>
    <div class="project-entry">
        <div class="col">
            <img class="project-image" :src="project.thumbnail" alt="">
            <div class="section-header">{{t('details','Details')}}</div>
            <p class="project-details" v-for="(element, index) in projectDetails" :key="index">
                {{ element }}
            </p>
            <div v-if="project.tags?.length">
                <div class="section-header">{{t('tags','Tags')}}</div>
                <span
                    v-for="(tag, j) in project.tags" :key="j"
                    class="tag-bubble"
                    :style="`background-color: ${getTagColor(tag)};`"
                >
                    {{ tag }}
                </span>
            </div>
        </div>
        <div class="col">
            <p id="modal-project-title" class="project-title">{{ project.title }}</p>
            <div class="section-header">{{t('description','Description')}}</div>
            <div class="text-display-area">{{ project.description || t('no description', '(No description)')}}</div>
            <div class="section-header">{{t('credits','Credits')}}</div>
            <div class="text-display-area">{{ project.credits || t('no credits', '(No credits)') }}</div>
        </div>
    </div>
</template>

<script>
import { utils } from '../myapp/src/utils';

export default {
    props: {
        project: {
            type: Object,
            required: false,
            default: {}
        }
    },
    computed: {
        projectDetails: function() {
            return this.project ?
                [
                    `${this.project.libraryDisplayName}`,
                    `${this.project.beadCount} ${this.t('beads')}`,
                    `${this.project.patternDisplayName}`,
                    `${this.project.sizeDescription}`,
                    `${this.t('created', 'Created')}: ${this.niceDate(this.project.dateCreated)}`,
                    `${this.t('updated', 'Updated')}: ${this.niceDate(this.project.dateModified)}`,
                ]: []
        },
    },
    methods: {
        getTagColor: utils.getTagColor,
        niceDate: utils.niceDate,
    }
}

</script>